import React, { PureComponent, PropTypes } from 'react';
import Spinner from '@atlaskit/spinner';
import { browserHistory } from 'react-router';
import { StatelessSelect as SingleSelect } from '@atlaskit/single-select';
import Lozenge from '@atlaskit/lozenge';

import { BASE_URL } from '../../config';

export default class ComponentDetailPage extends PureComponent {
  static propTypes = {
    componentName: PropTypes.string,
    isLoadingData: PropTypes.bool,
    defaultSelectedVersion: PropTypes.string,
    allVersions: PropTypes.array,
    isInternal: PropTypes.bool,
  };

  static defaultProps = {
    allVersions: [],
    isLoadingData: false,
  }

  state = {
    items: [],
    isSelectOpen: false,
  }

  componentDidMount = () => {
    const items = this.getItems(this.props.allVersions);
    this.setState({
      items: items,
    });
    if (this.props.defaultSelectedVersion) {
      const defaultSelected = this.getDefaultSelected(items, this.props.defaultSelectedVersion);
      this.setState({
        defaultSelected: defaultSelected
      });
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.allVersions && this.props.allVersions && nextProps.allVersions !== this.props.allVersions) {
      const items = this.getItems(nextProps.allVersions);
      this.setState({
        items: items,
      });
    }

    if (this.props.defaultSelectedVersion !== nextProps.defaultSelectedVersion) {
      const items = this.getItems(nextProps.allVersions);

      const defaultSelected = this.getDefaultSelected(items, nextProps.defaultSelectedVersion);
      this.setState({
        defaultSelected: defaultSelected
      });
    }
  }

  getItems = (allVersions) => {
    const { componentName } = this.props;
    return [{
      heading: '',
      items: allVersions.map(version => ({
        value: `${BASE_URL}/${componentName}/${version}/index.html`,
        content: version,
      })),
    }];
  }

  selectVersion = (item) => {
    browserHistory.push(item.value);
    this.setState({
      selectedVersion: item
    });
  }

  getAllItems = (groups) => {
    let allItems = [];
    groups.forEach((val) => {
      allItems = allItems.concat(val.items);
    });
    return allItems;
  }

  getDefaultSelected = (groups, version) => {
    return this.getAllItems(groups).filter(item => item.content === version)[0]
  }

  onOpenChange = (attrs) => {
    this.setState({ isSelectOpen: attrs.isOpen })
  }

  render() {
    const { componentName } = this.props;

    return (
      <div style={{display: 'flex', alignItems: 'center', margin: '24px 10px 28px 0px' }}>
        <h2 style={{marginBottom: 0}}>{componentName}</h2>

        <div style={{width: '100px', margin: '0 12px'}}>
          <SingleSelect
            items={this.state.items}
            onSelected={this.selectVersion}
            shouldFitContainer
            selectedItem={this.state.defaultSelected}
            onOpenChange={this.onOpenChange}
            isOpen={this.state.isSelectOpen}
          />
        </div>

        { this.props.isInternal ? <Lozenge appearance='removed'>Internal</Lozenge> : null }
        { this.props.isLoadingData ? <Spinner /> : null }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ComponentDetailPage/ComponentDetailHeader.jsx